import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { createRequestBody } from '../util';

@Injectable({ providedIn: 'root' })
export class AppsService {
    public resourceUrl = environment.SERVER_API_URL;
    constructor(private http: HttpClient) {}

    getResources() {
        return this.http.get(`${this.resourceUrl}api/res/all`, { observe: 'response' });
    }
    getListProduct(req?: any) {
        const body = createRequestBody(req);
        return this.http.post<any[]>(this.resourceUrl + 'api/product/programs/list/', body);
      }
}
